import React from "react";
import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import "./MembersModal.css";
import { useParams } from "react-router-dom";
import ProjectsService from "../../Services/ProjectsService";
function AddAPIDialog({
  ModalHeading,
  setAPIDilogOpen,
  addNewAPIAndProperties,
  env,
}) {
  const [optionValue, setOptionValue] = useState(0);
  const [showModal, setShow] = useState({ setAPIDilogOpen });
  const handleClose = () => {
    setAPIDilogOpen(false);
    setOptionValue(0);
  };
  const handleShow = () => setShow(true);
  const { companyId, projectId } = useParams();
  const [availableApis, setAvailableApis] = useState([]);

  useEffect(() => {
    ProjectsService.getProjectsAvailableApisByProjectId(projectId)
      .then((response) => {
        setAvailableApis(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleSubmit = async () => {
    alert("inside handle submit");
  };

  //const [selectedItem, setSelectedItem] = useState("Select from the list of available APIs")
  const handleChange = (e) => {
    setOptionValue(e.target.value);
    console.log("-------------------" + e.target.value);
  };
  return (
    <div
      className="modalBackground"
      style={{ opacity: "1", width: "100vw", height: "100vh" }}
    >
      <Modal
        animation={false}
        show={showModal}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard="False"
        dialogClassName="my-modal"
      >
        <Modal.Header className="apim-pop-header">
          <Modal.Title id="contained-modal-title-vcenter">
            {ModalHeading}
          </Modal.Title>
          <div className="col-sm d-flex justify-content-end">
            <a href='javascript:;' className="pop-close-wrap mpa-button-cancel bi bi-x-lg"  onClick={() => setAPIDilogOpen(false)}/>
        </div>
        </Modal.Header>
        <Modal.Body>
          <div className="custom-input-wrapp has-validation">
            <select
              className="form-select selectApiText"
              name="item-selected"
              value={optionValue}
              onChange={handleChange}
            >
              <option value={0} selected="">
                <p>Select from the list of available APIs</p>
              </option>
              {availableApis &&
                availableApis.map((api) => {
                  return <option value={api.id}>{api.name}</option>;
                })}
            </select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
          className="ui button comm-button-style primary"
            onClick={() => {
              addNewAPIAndProperties(optionValue, env, "");
              setAPIDilogOpen(false);
            }}
            id="addAPIDialogButton"
            disabled={optionValue == 0}
          >
            Add
          </Button>
          <Button
          className="ui button comm-button-style secondary"
            onClick={() => {
              setAPIDilogOpen(false);
            }}
            id="closeButton"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
export default AddAPIDialog;
